import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexColumn, FlexContainer } from 'styles/layouts';

export const HeaderCenter = styled.div`
  text-align: center;
`;

export const Background = styled.div<{ background?: string }>`
  height: 100%;
  width: 100%;
  max-width: 1440px;
  padding-bottom: 24px;
  margin: 0 auto;

  ${QUERIES.tabletAndUp} {
    background-image: url(${({ background }) => background ?? ''});
    background-position: top -172px center; // this positioning used in Figma design. We will improve it but after design update.
    background-repeat: no-repeat;
  }
`;

export const Wrapper = styled(FlexColumn)`
  width: 100%;
  gap: 42px;
  margin-top: 28px;
  ${QUERIES.tabletAndUp} {
    margin-top: 60px;
  }
`;

export const DescriptionWrapper = styled.div`
  max-width: 282px;
  margin: 0 auto;
  text-align: center;
  p {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
  }

  ${QUERIES.tabletAndUp} {
    max-width: 340px;
  }
`;

export const ResultsWrapper = styled(FlexColumn)`
  gap: 32px;
  margin-top: 18px;
`;

export const ResultsGrid = styled(FlexContainer)`
  gap: 8px;
  max-width: 1100px;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
`;
